import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Logo } from '../Logo';
import { Icon } from '../Icon';
import defaultLogoSrc from '../../assets/images/boundly-logo-dark-new.png';
import styles from './HeaderV7.css';

const cx = classnames.bind(styles);

function HeaderV7({ url, hasBackButton = false, onBack, questionNav = null, logoSrc = defaultLogoSrc }) {
    const progress = questionNav ? Math.round(questionNav.current / questionNav.total * 100) : 0;

    return (
        <header className={styles.root}>
            <div className={styles.row}>
                <div className={styles.side}>
                    {hasBackButton && (
                        <button
                            type='button'
                            className={styles.backButton}
                            onClick={() => onBack()}
                            aria-label='Go back'
                        >
                            <Icon name='arrowLeft' />
                        </button>
                    )}
                </div>
                {questionNav
                    ? <p className={styles.title}>{questionNav.title}</p>
                    : <Logo url={url} src={logoSrc} className={styles.logo} />
                }
                <div className={cx('side', 'sideRight')}>
                    {Boolean(questionNav) && (
                        <span className={styles.counter}>{questionNav.current} / {questionNav.total}</span>
                    )}
                </div>
            </div>
            {Boolean(questionNav) && (
                <div
                    className={styles.bar}
                    role='progressbar'
                    aria-valuenow={questionNav.current}
                    aria-valuemin={0}
                    aria-valuemax={questionNav.total}
                >
                    <span className={styles.barFill} style={{ width: `${progress}%` }} />
                </div>
            )}
        </header>
    );
}

HeaderV7.propTypes = {
    url: PropTypes.string.isRequired,
    hasBackButton: PropTypes.bool,
    onBack: PropTypes.func,
    questionNav: PropTypes.shape({
        title: PropTypes.string,
        current: PropTypes.number,
        total: PropTypes.number
    }),
    logoSrc: PropTypes.string
};

export {
    HeaderV7
};
